import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { MultiregistPage } from './multiregist';

@NgModule({
  declarations: [
    MultiregistPage,
  ],
  imports: [
    IonicPageModule.forChild(MultiregistPage),
  ],
})
export class MultiregistPageModule {}



// WEBPACK FOOTER //
// ./src/pages/multiregist/multiregist.module.ts